/**
 * Base URL for the API.
 * - dev (vite):     empty string -> requests hit /api/... and are proxied by Vite
 * - docker (nginx): empty string -> nginx proxies /api/... to the api container
 * - custom:         set VITE_API_BASE_URL at build time
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

/**
 * What the product is called on screen — GG Compass since Epic 23.
 *
 * One constant, used by the bar, the drawer, the footer and the empty dashboard. The
 * repository, the namespaces and the deployment keep the old name on purpose: renaming a
 * solution is a day of churn for a word nobody outside the team reads.
 *
 * `index.html` is the one place that cannot import this — the browser tab needs a title
 * before any script runs — so it repeats the name, and `env.test.ts` checks the two agree.
 * That copy is exactly what was missed at the rename: every screen said GG Compass and the
 * browser tab still said GameCompass.
 */
export const APP_NAME = 'GG Compass';
